module.exports = Backbone.Model.extend({
    defaults: {
		id:  0,
		file: '',
		dimension: {}
	}
});